// Scripts
/**
 * Envoi d'un email
 *
 * @param {*} elements
 * @param {*} url
 * @returns
 */ const sendEmail = async (elements, url)=>{
    let responseData = {};
    async function fetchData(elements) {
        const data = {
            page: elements["page"].value,
            name: elements["name"].value,
            phoneNumber: elements["phoneNumber"].value,
            email: elements["email"].value,
            sujet: elements["sujet"].value,
            message: elements["message"].value,
            politique: elements["politique"].checked
        };
        const fetchOptions = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
                "Access-Control-Allow-Headers": "*",
                "Access-Control-Allow-Methods": "GET, POST, OPTIONS"
            },
            body: JSON.stringify(data)
        };
        // console.log("fetchOptions", fetchOptions);
        try {
            // document.getElementById("sendButton").disabled = true;
            document.getElementById("sendingStatus").innerText = "Statut : Message en cours d'envoi...";
            // Envoi de la requête
            const response = await fetch(url, fetchOptions);
            // Traitement des retours de l'API
            let RequiredFieldsStatus = [];
            console.log("response.name", response.name ? "1" : "0");
            // Name
            if (!response.name) {
                RequiredFieldsStatus.push(true);
                document.getElementById("name").classList.remove("is-invalid");
                document.getElementById("name").classList.add("is-valid");
            } else {
                RequiredFieldsStatus.push(false);
                document.getElementById("name").classList.remove("is-valid");
                document.getElementById("name").classList.add("is-invalid");
            }
            // E-mail
            if (!response.email) {
                RequiredFieldsStatus.push(true);
                document.getElementById("email").classList.remove("is-invalid");
                document.getElementById("email").classList.add("is-valid");
            } else {
                RequiredFieldsStatus.push(false);
                document.getElementById("email").classList.remove("is-valid");
                document.getElementById("email").classList.add("is-invalid");
            }
            // document.getElementById("politique").checked = false;
            responseData = await response.json();
            console.log("R\xe9ponse :", responseData);
            document.getElementById("sendingStatus").innerText = "Statut : Message envoy\xe9 depuis l'adresse " + responseData.ip;
            document.getElementById("sendingStatusBox").className = "emailSendingStatusSent";
        } catch (error) {
            document.getElementById("sendingStatusBox").className = "emailSendingStatusError";
            document.getElementById("sendingStatus").innerText = "Statut : Erreur, message non envoy\xe9.";
            document.getElementById("sendButton").disabled = false;
            console.log("Il y a eu une erreur :\n", error);
        }
    }
    // Appel de la fonction fetchData avec les éléments du formulaire
    fetchData(elements);
    return responseData;
};
/**
 * Gestion des changements dans les champs du formulaire
 *
 * @param {*} elementName
 */ const handleChange = (elementName)=>{
    console.log("elementName : ", elementName);
    const pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const emailAddress = document.getElementById("email").value;
    let checkFieldStatus = [];
    const emailStatus = pattern.test(emailAddress);
    if (emailStatus) {
        checkFieldStatus.push(true);
        document.getElementById("email").classList.remove("is-invalid");
        document.getElementById("email").classList.add("is-valid");
    } else {
        checkFieldStatus.push(false);
        document.getElementById("email").classList.remove("is-valid");
        document.getElementById("email").classList.add("is-invalid");
    }
    checkFieldStatus.push(document.getElementById("name").value ? true : false);
    checkFieldStatus.push(document.getElementById("message").value ? true : false);
    checkFieldStatus.push(document.getElementById("politique").checked);
    /* Lorsque tous les champs indispensables sont correctement renseignés => le bouton [Envoyer] est activé */ document.getElementById("sendButton").disabled = !checkFieldStatus.every((status)=>status === true);
};
/* --------------------------------------------------------------------------------------- */ /* FIN DE LA ZONE DES FONCTIONS */ /* --------------------------------------------------------------------------------------- */ if (window.innerWidth < 768) document.getElementById("logo").style.height = "32px";
else document.getElementById("logo").style.height = "64px";
// Select elements we'll need to manipulate
const hamburger = document.querySelector(".hamburger");
const navMenu = document.querySelector(".nav-menu");
const navLinks = document.querySelectorAll("nav a");
// Toggle mobile menu when hamburger is clicked
hamburger.addEventListener("click", ()=>{
    // Toggle active class on hamburger and nav menu
    hamburger.classList.toggle("active");
    navMenu.classList.toggle("active");
    // Add accessibility attributes
    const isExpanded = hamburger.classList.contains("active");
    hamburger.setAttribute("aria-expanded", isExpanded);
});
// Close mobile menu when a nav link is clicked
navLinks.forEach((link)=>{
    link.addEventListener("click", ()=>{
        // Only take action if hamburger menu is visible (mobile view)
        if (window.innerWidth <= 1280) {
            hamburger.classList.remove("active");
            navMenu.classList.remove("active");
            hamburger.setAttribute("aria-expanded", false);
        }
    });
});
// Add accessibility support
function addAccessibility() {
    // Add ARIA attributes to hamburger menu
    hamburger.setAttribute("aria-label", "Bascule entre navigation et menu");
    hamburger.setAttribute("aria-expanded", false);
    hamburger.setAttribute("role", "button");
    hamburger.setAttribute("tabindex", "0");
    // Allow keyboard activation of hamburger menu
    hamburger.addEventListener("keydown", (e)=>{
        if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            hamburger.click();
        }
    });
}
// Initialize accessibility features
addAccessibility();
// Go to Anchor
function goToAnchor(anchor) {
    const droitAnchor = document.getElementById(anchor);
    const loc = document.location.toString().split("#")[0];
    droitAnchor.style.marginTop = "80px";
    droitAnchor.style.height = "auto";
    droitAnchor.style.opacity = 1;
    document.location = loc + "#" + anchor;
    return false;
}
// Close the panel and scroll to Competence anchor
const closePanel = (anchor)=>{
    const droitAnchor = document.getElementById(anchor);
    const loc = document.location.toString().split("#")[0];
    droitAnchor.style.height = 0;
    droitAnchor.style.opacity = 0;
    droitAnchor.style.marginTop = 0;
    document.location = loc + "#expertise";
    return false;
};
// Hide the bottom information bar when scrolling
let previousScrollY = 0;
const hideBottomBar = ()=>{
    console.log("prout !");
    let { scrollTop } = document.getElementById("main-content");
    if (previousScrollY !== scrollTop) document.getElementById("footer").style.bottom = "-100px";
    if (scrollTop < 100) document.getElementById("footer").style.bottom = 0;
    previousScrollY = scrollTop;
    return false;
};
/**
 * Send email when user clicks on form submit button
 */ document.getElementById("myForm").addEventListener("submit", function(event) {
    event.preventDefault();
    var elements = this.elements;
    /* Sélectionner l'API :
        http://localhost:3042/post : sur le PC local
        https://cornut-avocat.fr/post : en production
      */ // const url = "http://localhost:3042/post";
    const url = "http://localhost:3042/post";
    sendEmail(elements, url);
}); /* ------------------------------------------------------------------------------ */  /* FIN DU CODE JS */  /* --------------------------------------------------------------------------------------- */ 

//# sourceMappingURL=strategavocats-2.6f3a8932.js.map
